import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useSWR from 'swr';
import { axios, dataFetcher, endpoints, baseUrl, cloudBaseUrl, getToken } from 'Api';
import { Skeleton } from '@mui/material';
import { AppContext } from 'Context';
import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from 'Components';
import CustomButton from 'Components/button/CustomButton';
import Logo from '../../../../Assets/published.png';
import { StoragePage } from '../components/page';
import { videoArray } from './DataArray';
import { photoArray } from './PhotoArray';
import Publish from '../PublishUi/Publish';
import Sort from '../../../../Assets/sort.png';
import styles from './index.module.css';
import Shimmer from '../Shimmer';
import EditPublish from '../PublishUi/EditPublish';

export const AlbumCloudStorage = () => {
    const location = useLocation();
        const { albumid } = useParams();
  const [data, setData] = useState({ results: [], next: null });
  const [loading, setLoading] = useState(false);
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [page, setPage] = useState(1);
  const containerRef = useRef(null);
  const {
    storageSearchTerm,
    storageSelectedDate,
    storageTabTitle,
    storageSelectedItems,
    setStorageSelectedItems,
    setOpenX,
      cloudToken,
      setAppSnackbar,
    albumDetails
    } = useContext(AppContext);
  const [thumbnailSelected, setThumbnailSelected] = useState();
  const [addToProjector, setAddToProjector] = useState(false);
  const [detailsData, setDetailsData] = useState({
    title: '',
    description: '',
    visibility: 2,
    group: [], // ✅ Must be an array!
  });
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / 1024 ** i).toFixed(2)} ${sizes[i]}`;
  };
  const groupByDate = (files) => {
    if (!Array.isArray(files)) return {};
    return files.reduce((acc, file) => {
      const dateObj = new Date(file.uploaded_at);
      const formattedDate = dateObj.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(file);
      return acc;
    }, {});
  };
  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const groupedFiles = groupByDate(data?.results);
  const handleSelect = (item) => {
    const isAlreadySelected = storageSelectedItems.some(
      (selected) => selected.id === item.id
    ); // assuming `id` is unique
    if (isAlreadySelected) {
      setStorageSelectedItems(
        storageSelectedItems.filter((selected) => selected.id !== item.id)
      );
    } else {
      setStorageSelectedItems([...storageSelectedItems, item]);
    }
  };

      const { isValidating: gettingAlbums, mutate: getAlbumDetails } = useSWR(
        [endpoints.getMyAlbumDetail, albumid],
        {
          fetcher: (url, album_id) => dataFetcher(url, { album_id }),
          onSuccess: ({ success, data }) => {
            if (success) {
                setData(data);
            } else {
              setAppSnackbar({
                isVisible: true,
                type: 'error',
                message: 'Oops! Something went wrong',
              });
              }
                 setLoading(false);
          },
            onError: () => {
                 setLoading(false);
            setAppSnackbar({
              isVisible: true,
              type: 'error',
              message: 'Oops! Something went wrong',
            });
          },
        }
      );
    useEffect(() => {
setLoading(true);
getAlbumDetails();
  }, []);

    useEffect(() => {
      // Clear selected items when route changes
      setStorageSelectedItems([]);
    }, [location.pathname]); // triggered every time the path changes

const addAlbum = async () => {
  try {
    const response = await axios.post(
      `${baseUrl}/cloud/addAlbum`,
      {
        token: getToken(),
        title: detailsData?.title,
        description: detailsData.description,
        // group: groupId.toString(),
        visibility: detailsData?.visibility.toString(),
        icon: storageSelectedItems[0]?.pre_url,
        photos: storageSelectedItems?.map((obj) => obj?.pre_url),
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    console.log('Album added successfully:', response.data);
    setStorageSelectedItems([]);
    return response.data;
  } catch (error) {
    console.error('Error adding album:', error.response?.data || error.message);
    throw error;
  }
};
  const publishHandler = () => {
    if (addToProjector) {
      addAlbum();
      setAddToProjector(false);
    } else {
        setAddToProjector(true);
            if (storageSelectedItems?.length === 1) {
      setDetailsData({
        title: storageSelectedItems[0]?.title ?? '',
        duration: undefined,
        height: undefined,
        width: undefined,
        description: storageSelectedItems[0]?.description ?? '',
        thumbnail: storageSelectedItems[0]?.draft_thumbnails ?? '',
        visibility: Number(storageSelectedItems[0]?.visibility ?? 2),
        group: [], // Keep default unless populated
      });
      setAddToProjector(true);
    }
    }
  };
  console.log('storageSelectedItems', storageSelectedItems, detailsData);
  return (
    <StoragePage
      title={
        !loading && data[0]?.photos?.length > 0
          ? `${data[0]?.photos?.length} Photos on ${data[0]?.title}`
          : albumDetails?.title
      }
      // addActionName={viewerText?.addViewer || 'Add viewer'}
      // addActionName={'Add viewer'}
      // link={Pathname.grantAccess}
    >
      <div className={styles.viewersDiv}>
        <div className={styles.aboveGrid}>
                <div className={styles.topix}>
              <div className={styles.photsContainer} ref={containerRef}>
                {loading ? (
                  <div className={styles.shimmer}>
                    <Shimmer type="photos" />
                  </div>
                ) : data[0]?.photos?.length > 0 ? (
                  data[0]?.photos?.map((item, index) => (
                    <div
                      className={styles.gridPhx}
                      key={item?.id}
                      role="button"
                      tabIndex={0}
                      onClick={() => handleSelect(item)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSelect(item);
                        }
                      }}
                    >
                      <Checkbox
                        checked={storageSelectedItems?.some(
                          (selected) => selected.id === item.id
                        )}
                        icon={<></>} // ✅ safely renders nothing
                        checkedIcon={<CheckCircleIcon />} // ✅ shown only when selected
                        sx={{
                          color: '#e6dfda',
                          '&.Mui-checked': {
                            color: '#e6dfda',
                          },
                        }}
                        style={{
                          position: 'absolute',
                          top: '40%',
                          left: '42%',
                          zIndex: 2,
                          borderRadius: 4,
                          padding: 0,
                          pointerEvents: 'none', // allow click-through
                        }}
                      />

                      <img src={item?.imagekit_url} className={styles.eachbyimg} alt={item?.name} />
                      {item?.draft_id !== null && (
                        <img
                          className={styles.isStream}
                          src={Logo}
                          alt={item?.name}
                        />
                      )}
                    </div>
                  ))
                ) : (
                  <div className={styles.noData}>No data found</div>
                )}
                {loadingNextPage
                  && Array.from({ length: 16 }).map((_, index) => (
                    <div
                      className={styles.gridItemX}
                      key={index + data.results.length}
                    >
                      <Skeleton
                        variant="rectangular"
                        height={130}
                        width={100}
                        animation="wave"
                        sx={{
                          borderRadius: '12px',
                        }}
                      />
                    </div>
                  ))}
              </div>
                </div>
        </div>
        {storageSelectedItems?.length > 0 && (
          <div className={styles.pendingViewersContainer}>
            <EditPublish
              type="photos"
              addToProjector={addToProjector}
              setSelectedCheckedItems={setStorageSelectedItems}
              selectedCheckedItems={storageSelectedItems}
              formatFileSize={formatFileSize}
              handleDetailsChange={handleDetailsChange}
              detailsData={detailsData}
              setDetailsData={setDetailsData}
              thumbnailSelected={thumbnailSelected}
              setThumbnailSelected={setThumbnailSelected}
            />

            <div className={styles.buttonsfleximo}>
              <CustomButton border="red" name="Delete" />
              <CustomButton
                disabled={storageSelectedItems?.length < 1}
                onClick={publishHandler}
                border="#5AA5EF"
                name="Update Album"
              />
            </div>
          </div>
        )}
      </div>
    </StoragePage>
  );
};
